import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/cormorant-garamond/700.css';
import '@fontsource/cormorant-garamond/500-italic.css';
import '@fontsource/alegreya-sans/400.css';
import '@fontsource/alegreya-sans/500.css';
import '@fontsource/alegreya-sans/700.css';
import '@fontsource/special-elite/400.css';
import '@fontsource/cinzel/500.css';
import '@fontsource/cinzel/700.css';
import '@fontsource/cinzel-decorative/700.css';
import './styles/app.css';
import './styles/hud.css';
import './styles/ui.css';
import { App } from './app/App';

import './audio/sfx';
import { loadProps } from './scene/assets';
import { loadCardArt } from './scene/cardFaces';
import { pack } from './game/content';
if (import.meta.env.DEV) void import('./app/autoplay');
// Start fetching the 3D prop library while fonts load and the menu renders.
void loadProps().catch(() => undefined);

// Canvas-composed labels need the web fonts loaded first (docs/07 §9). `fonts.ready` alone only
// waits for fonts already in use, so request the faces the canvas uses explicitly.
const faces = ['italic 500 23px "Cormorant Garamond"', '700 56px "Cormorant Garamond"', '500 38px "Alegreya Sans"', '400 20px "Special Elite"', '700 56px "Cinzel"', '500 40px "Cinzel"', '700 56px "Cinzel Decorative"'];
// Card illustrations are drawn into the card faces, so they must be in before the first face is.
const art = loadCardArt([...pack.spells, ...pack.actions, ...pack.problems, ...pack.identities].map((d) => d.id));
void Promise.all([...faces.map((f) => document.fonts.load(f).catch(() => [])), art.catch(() => undefined)]).then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
